'use strict';

var dateFns = require('date-fns');
var partsToTimestamp = require('./partsToTimestamp.cjs');

const parseISODatePartIntervalToTimestampInterval = ({
  dateInterval,
  timeZone,
  inclusiveEnd = false
}) => {
  const start = partsToTimestamp({
    isoDatePart: dateInterval.start,
    isoTimePart: "00:00:00",
    timeZone
  });
  let end;
  if (!inclusiveEnd) {
    end = partsToTimestamp({
      isoDatePart: dateInterval.end,
      isoTimePart: "00:00:00",
      timeZone
    });
  } else {
    end = dateFns.addDays(
      partsToTimestamp({
        isoDatePart: dateInterval.end,
        isoTimePart: "00:00:00",
        timeZone
      }),
      1
    ).getTime();
  }
  return { start, end };
};

module.exports = parseISODatePartIntervalToTimestampInterval;
//# sourceMappingURL=parseISODatePartIntervalToTimestampInterval.cjs.map
